import CryptoJS from "crypto-js";

const SECRET_KEY = import.meta.env.VITE_SECRET_KEY || "";

function setSession(key, token, days) {
    // const now = new Date();
    // const expiryTime = now.getTime() + (days * 24 * 60 * 60 * 1000);
    // const item = {
    //     value: token,
    //     expiry: expiryTime,
    // };
    sessionStorage.setItem(key, JSON.stringify(token));
}

function getSession(key) {
    const itemStr = JSON.parse(sessionStorage.getItem(key));
    // if (!itemStr) return null;

    // const item = JSON.parse(itemStr);
    // const now = new Date();

    // if (now.getTime() > item.expiry) {
    //     sessionStorage.removeItem(key);
    //     return null;
    // }

    // return item.value;
    return itemStr;
}

export const encryptId = (id) => {
    const encrypted = CryptoJS.AES.encrypt(id.toString(), SECRET_KEY).toString();
    // Make it URL-safe
    return encrypted.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

export const decryptId = (encryptedId) => {
    try {
        // Restore original Base64
        const base64 = encryptedId.replace(/-/g, "+").replace(/_/g, "/");
        const bytes = CryptoJS.AES.decrypt(base64, SECRET_KEY);
        return bytes.toString(CryptoJS.enc.Utf8);
    } catch (e) {
        return null;
    }
};


export default { setSession, getSession, encryptId, decryptId };
